import { updateApprovalThreshold } from './API';

const UpdateApprovalThreshold = async (
  accessToken,
  groupName,
  newApprovalThreshold
) => {
  try {
    const response = await updateApprovalThreshold(
      accessToken,
      groupName,
      newApprovalThreshold
    );
    if (response?.data.length === 0) {
      return { success: false, data: 'No data present' };
    }
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error getting data: ', error.message);
    return {
      success: false,
      data: error?.response?.data?.message
        ? error?.response?.data?.message
        : 'Error'
    };
  }
};

export default UpdateApprovalThreshold;
